import { render } from "./FTPSettingsModal.vue?vue&type=template&id=60f90960"
import script from "./FTPSettingsModal.vue?vue&type=script&lang=js"
export * from "./FTPSettingsModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__